<!-- 框架 -->
<template>
	<el-container class="appWrapper">
		<el-container>
			<el-header style="z-index: 100">
				<navbar ref="layoutNavbar" :isCollapse.sync="isCollapse" :keepAliveComponentData="keepAliveComponentData"></navbar>
			</el-header>
			<el-main>
				<transition name="fade-transform" mode="out-in">
					<div ref="keepAliveContainer">
						<!-- 页签栏 -->
						<div class="pageTab" v-if="$route.name !== 'mainPage'">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<el-breadcrumb-item>您的位置：<span style="cursor: pointer" @click="$router.push('/')">首页</span></el-breadcrumb-item>
								<el-breadcrumb-item v-for="(item, index) in levelList" :key="index">{{ item.meta.title }}</el-breadcrumb-item>
							</el-breadcrumb>
						</div>
						<router-view :key="$route.fullPath" @close="close($event)"></router-view>
					</div>
				</transition>
				<footer-info></footer-info>
			</el-main>
			<el-footer class="footer_area">
				<div @click.stop="jumpConnect">{{ copyrightText }}</div>
			</el-footer>
		</el-container>
	</el-container>
</template>

<script>
import Navbar from '@/pageLayout/navbar';
import FooterInfo from '@/pageLayout/footerInfo';

export default {
	name: 'Layout',
	data() {
		return {
			copyrightText: '',
			isCollapse: false,
			keepAliveComponentData: null,
			levelList: '',
			breadcrumb: true,
		};
	},
	components: {
		Navbar,
		FooterInfo,
	},
	created() {
		this.getBreadcrumb();
	},
	computed: {},
	mounted() {
		if (this.$refs.keepAliveContainer) {
			this.keepAliveComponentData = this.$refs.keepAliveContainer.childNodes[0].__vue__; //获取keep-alive的控件实例对象
		}
		// this.copyrightText = this.$DICT.copyrightText;
		this.getRefgrpInfo();
	},
	methods: {
		// 获取版本号
		getRefgrpInfo() {
			this.$API.getWebVersion({}, (res) => {
				for(let i = 0; i < res.data.length; i++) {
					if(res.data[i].refcd === this.$DICT.platform){
						this.copyrightText = this.$DICT.copyrightText + res.data[i].var1;
					}
				}
			});
		},
		// 面包屑加载
		getBreadcrumb() {
			let sendData = { pageNum: 1, pageSize: 10 };
			let matched = this.$route.matched.filter((item) => {
				if (item.name) {
					return true;
				}
			});
			// 产品服务单独处理
			matched.forEach((item) => {
				if (item.name === 'productIntroduction') {
					this.$API.getProductList(sendData, (res) => {
						res.list.forEach(item=>{
							if(item.objid === this.$router.currentRoute.query.objid){
								matched[1].meta.title = item.product_name
							}
						})
					});
				}
			});
			this.levelList = matched;
		},
		// refreshPage() {
		// 	this.$refs.layoutNavbar.refreshPage();
		// },
		// close(e){
		// 	this.$refs.layoutNavbar.close(e);
		// },
		//跳转备案链接
		jumpConnect() {
			window.open('https://beian.miit.gov.cn/', '_blank');
		},
	},
	watch: {
		isCollapse: function (newValue, oldValue) {
			if (newValue) {
			}
		},
		$route:{
			deep:true,
			handler(){
				this.getBreadcrumb();
			}
		},
	},
};
</script>

<style>
.pageTab {
	width: 1200px;
	margin: auto;
	padding: 20px 30px;
}
.appWrapper {
	position: fixed;
	width: 100%;
	height: 100%;
}

.footer_area {
	height: 40px !important;
	line-height: 40px;
	cursor: pointer;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
	transition: all 0.5s;
}

.fade-transform-enter {
	opacity: 0;
	transform: translateX(-30px);
}

.fade-transform-leave-to {
	opacity: 0;
	transform: translateX(30px);
}
</style>



// WEBPACK FOOTER //
// src/pageLayout/layout.vue